import { Breakpoint, Breakpoints } from './media-query.types';

export const breakpoints: {
    [key in Breakpoints]: Breakpoint;
} = {
    mobile: {
        size: 320,
        next: 479.5,
        active: false,
    },
    mobilePlus: {
        size: 480,
        next: 767.5,
        active: false,
    },
    tabletPortrait: {
        size: 768,
        next: 1023.5,
        active: false,
    },
    tabletLandscape: {
        size: 1024,
        next: 1259.5,
        active: false,
    },
    laptop: {
        size: 1260,
        next: 1599.5,
        active: false,
    },
    desktop: {
        size: 1600,
        active: false,
    },
};
